import { _PriceFreezeProvider } from '@/providers';
import { withFlightSelection } from '@/HOC/withFlightSelection';

export const IntegratedPriceFreezeProvider =
  withFlightSelection(_PriceFreezeProvider);
